/*@flow*/
import type { Node } from 'react';
import React from 'react';
import OverlayFactory from 'comps/OverlayFactory';
import { Tooltip } from 'react-bootstrap';

type PropsT = {
  title?: string,
  children?: any,
  onClick?: Function,
  disabled?: boolean,
  className?: string,
  testid?: string,
};

const TooltipWrapper = OverlayFactory(Tooltip);

export default (props: PropsT): Node => (
  <TooltipWrapper
    placement="left"
    content={props.title}
    id={props.className || ''}
  >
    <a
      title={props.title}
      disabled={props.disabled}
      data-testid={props.testid}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        props.onClick && props.onClick(e);
      }}
      className={props.className}
    >
      {props.children}
    </a>
  </TooltipWrapper>
);
